module.exports = __webpack_public_path__ + "static/media/LogicWedge2_5_drag_3.00bdfd43.png";